"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.axios = exports.Result = void 0;
const axios_1 = __importDefault(require("axios"));
exports.axios = axios_1.default;
var utils_1 = require("@invivodf/utils");
Object.defineProperty(exports, "Result", { enumerable: true, get: function () { return utils_1.Result; } });
// eslint-disable-next-line import-x/export
__exportStar(require("axios"), exports);
__exportStar(require("./wrapper"), exports);
__exportStar(require("./httpError"), exports);
__exportStar(require("./utils"), exports);
